import React from 'react'
import { useNavigate } from 'react-router'
import { styled } from '@mui/material/styles'
import * as Yup from 'yup'
import { Formik } from 'formik'

import { Alert as MuiAlert, Button, TextField as MuiTextField } from '@mui/material'
import { spacing } from '@mui/system'

import useAuth from '../../hooks/useAuth'

const Alert = styled(MuiAlert)(spacing)

const TextField = styled(MuiTextField)(spacing)

function ResetPassword() {
    const navigate = useNavigate()
    const { resetPassword } = useAuth()

    return (
        <Formik
            initialValues={{
                email: '',
                submit: false,
            }}
            validationSchema={Yup.object().shape({
                email: Yup.string()
                    .email('Måste vara en giltig epostadress')
                    .max(255)
                    .required('Epostadress måste anges'),
            })}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                try {
                    // Call the resetPassword function
                    const response = await resetPassword(values.email)

                    if (response.success) {
                        // Redirect to the reset-password-code page with email and showMessage query parameters
                        navigate(`/auth/reset-password-code?email=${encodeURIComponent(values.email)}&showMessage=true`)
                    } else {
                        // If there was an error, show the error message
                        setStatus({ success: false })
                        setErrors({ submit: response.message })
                        setSubmitting(false)
                    }
                } catch (error) {
                    // Fallback error handling
                    const message = error.message || 'Något gick fel'

                    setStatus({ success: false })
                    setErrors({ submit: message })
                    setSubmitting(false)
                }
            }}
        >
            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                <form noValidate onSubmit={handleSubmit}>
                    {errors.submit && (
                        <Alert mt={2} mb={1} severity='warning'>
                            {errors.submit}
                        </Alert>
                    )}
                    <TextField
                        type='email'
                        name='email'
                        label='Epostadress'
                        value={values.email}
                        error={Boolean(touched.email && errors.email)}
                        fullWidth
                        helperText={touched.email && errors.email}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        my={3}
                    />
                    <Button type='submit' fullWidth variant='contained' color='primary' disabled={isSubmitting}>
                        Återställ lösenord
                    </Button>
                </form>
            )}
        </Formik>
    )
}

export default ResetPassword
